<template>
  <div class="side-menu box">
    <div class="pure-menu">
      <ul class="pure-menu-list">
        <li class="pure-menu-item" @click="clickMenu">
          <router-link :to="{ name: 'transports' }" class="pure-menu-link">交通費管理</router-link>
        </li>
        <li class="pure-menu-item" @click="clickMenu" v-show="isAdmin">
          <router-link :to="{ name: 'user' }" class="pure-menu-link">ユーザー管理</router-link>
        </li>
        <li class="pure-menu-item" @click="clickMenu" v-show="isAdmin">
          <router-link :to="{ name: 'company' }" class="pure-menu-link">会社情報</router-link>
        </li>
        <li class="pure-menu-item logout">
          <div class="pure-menu-link" @click="logout">ログアウト</div>
        </li>
        <li class="pure-menu-item" @click="clickMenu" v-show="isAdmin">
          <router-link :to="{ name: 'withdrawal' }" class="pure-menu-link withdrawal">退会</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    clickMenu() {
      if (window.innerWidth <= 420) {
        this.$parent.clickMenu()
      }
    },

    logout() {
      if (window.confirm("ログアウトしますか？")) {
        this.$store.dispatch("logout").then(() => {
          this.$router.push({ name: "index" })
        })
      }
    }
  },

  computed: {
    isAdmin() {
      return this.$store.state.store.user.auth == 0
    }
  }
}
</script>

<style scoped>
.side-menu {
  width: 150px;
  height: 100%;
  padding-top: 15px;
  background: linear-gradient(135deg, lavenderblush, #83ccd2);
}

.router-link-active {
  background-color: #FFF;
  font-weight: bold;
}

.logout {
  cursor: pointer;
}

.withdrawal {
  color: #dc143c;
  margin-top: 195%;
}

@media screen and (max-width: 420px) {
  .side-menu {
    width: 100%;
  }
}
</style>
